export default function CommentFrom(){
    return(
        <div class="comment-form mb-10">
    <h3 class="post-title mb-35">Post Comment</h3>
    <form class="contact-form" action="">
        <div class="row">
            <div class="col-12">
                <div class="input-box text-input mb-20">
                    <textarea name="message" cols="30" rows="10"
                        placeholder="Type your comments...."></textarea>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="input-box mb-20">
                    <input type="text" placeholder="Type your name...." />
                </div>
            </div>
            <div class="col-lg-12">
                <div class="input-box mail-input mb-20">
                    <input type="text" placeholder="Type your email...." />
                </div>
            </div>
            <div class="col-lg-12">
                <div class="input-box sub-input mb-30">
                    <input type="text" placeholder="Type your website...." />
                </div>
            </div>
            <div class="col-12 mb-15">
                <button class="form-btn form-btn4"><i class="fal fa-comments"></i> Post
                    Comment</button>
            </div>
        </div>
    </form>
</div> 
    )
}
 